function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-mgt {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 0.75px;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ic-migr-trans",
  transform: "translate(0.53 0.375)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_15753",
  "data-name": "Group 15753",
  transform: "translate(-461.467 -960.848)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_15752",
  "data-name": "Group 15752"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_528",
  "data-name": "Line 528",
  className: "cls-mgt",
  x1: 0.001,
  y2: 4.172,
  transform: "translate(469.49 964.857)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9523",
  "data-name": "Path 9523",
  className: "cls-mgt",
  d: "M465.7,966.03v-3.072h0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9524",
  "data-name": "Path 9524",
  className: "cls-mgt",
  d: "M473.28,962.956v3.085"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9525",
  "data-name": "Path 9525",
  className: "cls-mgt",
  d: "M466.61,967.706l2.88,1.323,2.836-1.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9526",
  "data-name": "Path 9526",
  className: "cls-mgt",
  d: "M473.279,962.957l-3.789,1.9-3.789-1.9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9527",
  "data-name": "Path 9527",
  className: "cls-mgt",
  d: "M473.279,962.957l-3.789-2.109-3.79,2.109"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_15756",
  "data-name": "Group 15756",
  transform: "translate(-461.467 -960.848)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_15755",
  "data-name": "Group 15755"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9528",
  "data-name": "Path 9528",
  className: "cls-mgt",
  d: "M473.828,969.407l-.034-2.672a.736.736,0,0,0-.746-.727h0a.737.737,0,0,0-.728.746l.013.956a.562.562,0,0,1-.22.453l-.058.045a1.126,1.126,0,0,0-.439.906l.02,1.6a1.125,1.125,0,0,0,.286.734l1.657,1.859"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9529",
  "data-name": "Path 9529",
  className: "cls-mgt",
  d: "M473.279,962.957a8.371,8.371,0,0,1,1.68,1.537l.929,1.154.067,5.272"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_15754",
  "data-name": "Group 15754"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9530",
  "data-name": "Path 9530",
  className: "cls-mgt",
  d: "M477.467,971.448l-.743-.718a.273.273,0,0,0-.385.006l-2.939,3.015a.271.271,0,0,0,.006.386l.741.717"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_15759",
  "data-name": "Group 15759",
  transform: "translate(-461.467 -960.848)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_15758",
  "data-name": "Group 15758"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9531",
  "data-name": "Path 9531",
  className: "cls-mgt",
  d: "M465.107,969.407l.033-2.672a.738.738,0,0,1,.747-.727h0a.737.737,0,0,1,.727.746l-.012.956a.564.564,0,0,0,.219.453l.059.045a1.125,1.125,0,0,1,.438.906l-.02,1.6a1.124,1.124,0,0,1-.285.734l-1.658,1.859"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9532",
  "data-name": "Path 9532",
  className: "cls-mgt",
  d: "M462.98,970.92l.066-5.272.93-1.154a8.737,8.737,0,0,1,1.725-1.537"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_15757",
  "data-name": "Group 15757"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9533",
  "data-name": "Path 9533",
  className: "cls-mgt",
  d: "M461.467,971.448l.743-.718a.273.273,0,0,1,.385.006l2.94,3.015a.273.273,0,0,1-.006.386l-.742.717"
})))));

function SvgMigrationTransfer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.92,
    height: 14.912,
    viewBox: "0 0 15 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigrationTransfer);
export default __webpack_public_path__ + "static/media/migration-transfer.e648d547.svg";
export { ForwardRef as ReactComponent };